import React from "react";
import logo from "../../assets/layout_assets/spotifylogo.png";
import {
  RiHome2Line,
  RiSearchLine,
  RiAddBoxFill,
  RiHeart2Fill,
  RiDownloadCloud2Line,
} from "react-icons/ri";
import { BiLibrary } from "react-icons/bi";
import { Link, NavLink, useNavigate } from "react-router-dom";
export default function LeftLayout() {
  const navLinkStyle = ({ isActive }) => {
    return {
      opacity: isActive ? 1 : "",
    };
  };

  return (
    <div>
      <div className="fixed left-0 top-0 bg-black w-60 h-screen flex flex-col justify-between pl-6 p-2 z-10">
        <div>
          <NavLink to="/">
            <img src={logo} alt="" className="w-32 mb-6 cursor-pointer" />
          </NavLink>
          <NavLink
            to="/"
            style={navLinkStyle}
            className="flex items-center mb-4 opacity-50 hover:opacity-100 transition-all cursor-pointer ease-in duration-200 "
          >
            <RiHome2Line className="text-white text-2xl" />
            <h4 className="text-white text-sm ml-4">Home</h4>
          </NavLink>
          <NavLink
            style={navLinkStyle}
            className="flex items-center mb-4 opacity-50 hover:opacity-100 transition-all cursor-pointer ease-in duration-200 "
            to="/search"
          >
            <RiSearchLine className="text-white text-2xl" />
            <h4 className="text-white text-sm ml-4">Search</h4>
          </NavLink>
          <NavLink
            to="/library/playlist"
            style={navLinkStyle}
            className="flex items-center mb-4 opacity-50 hover:opacity-100 transition-all cursor-pointer ease-in duration-200 "
          >
            <BiLibrary className="text-white text-2xl" />
            <h4 className="text-white text-sm ml-4">Your Library</h4>
          </NavLink>
          <div className="flex items-center mb-4 opacity-50 hover:opacity-100 transition-all cursor-not-allowed ease-in duration-200 mt-6">
            <RiAddBoxFill className="text-white text-3xl" />
            <h4 className="text-white text-sm ml-4">Create Playlist</h4>
          </div>
          <div className="flex items-center mb-4 opacity-50 hover:opacity-100 transition-all cursor-not-allowed ease-in duration-200">
            <RiHeart2Fill className="text-white text-3xl" />
            <h4 className="text-white text-sm ml-4">Liked Songs</h4>
          </div>
        </div>
        <div className="flex items-center mb-28 opacity-50 hover:opacity-100 transition-all cursor-pointer ease-in duration-200">
          <RiDownloadCloud2Line className="text-white text-2xl" />
          <h4 className="text-white text-sm ml-4 cursor-not-allowed">
            Install App
          </h4>
        </div>
      </div>
    </div>
  );
}
